module.exports = __webpack_public_path__ + "static/media/jefferyPic.0a15ce38.png";